export const initialState = {
	commands: [],
	path: "root@kevin:~$",
	alert: false,
};
